import React from "react";
import "./Icon.css";

export type IconProps = {
  disabled?: boolean;
  variant?: "primary" | "secondary" | "tertiary";
  size?: "sm" | "md" | "lg";
  className?: string;
  border?: boolean;
//   isLoading: boolean;
  icon: React.ReactNode;
};

export const Icon = ({
    disabled = false,
    variant = "primary",
    size = "md",
    className,
    border = false,
    icon,
    ...props
}: IconProps & React.ComponentPropsWithoutRef<"div">) => {

    const getVariantClass = () => {
        switch (variant) {
            case "primary":
                return "ds2-icon-primary";
            case "secondary":
                return "ds2-icon-secondary";
            case "tertiary":
                return "ds2-icon-tertiary";
            default:
                return "ds2-icon-primary";
        }
    }

    const getSizeStyles = () => {

        switch (size) {
            case "sm":
                return {height: "16px", width: "16px", padding: "2px"};
            case "md":
            case "lg":
            default:
                return {height: "24px", width: "24px", padding: "4px"};
        }
    }

    const getInnerSizeStyles = () => {
    
        switch (size) {
            case "sm":
                return {padding: "0px", gap: "2px", fontSize: ".85rem"};
            case "md":
            case "lg":
            default:
                return {padding: "8px 12px", gap: "4px", fontSize: "1rem"};
        }
    }

    const getBorderStyles = () => {
        switch (variant) {
            case "primary":
                return "var(--button-border-primary)";
            case "secondary":
                return "var(--button-border-secondary)";
            case "tertiary":
                return "var(--button-border-tertiary)";
            default:
                return "var(--button-border-primary)";
        }
    }
    
    return (
        <div 
            // disabled={disabled} 
            className={getVariantClass() + " " + className}
            style={{
                ...getSizeStyles(), 
                cursor: disabled ? "default" : "pointer",
                pointerEvents: disabled ? "none" : "auto",
                border: border ? getBorderStyles() : "none",
                opacity: disabled ? 0.5 : 1,
            }}
            {...props} 
        >     
           {icon}
        
        </div>
    );
}  